function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0h26v26H0z",
  "data-name": "Path 78",
  fill: "none",
  opacity: 0.87
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 2a11 11 0 1011 11A10.99 10.99 0 0013 2zm4.73 15.73a1.1 1.1 0 01-1.551 0L13 14.551 9.821 17.73a1.1 1.1 0 01-1.551-1.551L11.449 13 8.27 9.821A1.1 1.1 0 019.821 8.27L13 11.449l3.179-3.179a1.1 1.1 0 011.551 1.551L14.551 13l3.179 3.179a1.116 1.116 0 010 1.551z",
  "data-name": "Path 79",
  fill: "#707070"
});

var SvgDelete = function SvgDelete(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/delete.b91c4e05.svg";
export { SvgDelete as ReactComponent };